import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
*,*::before,*::after{box-sizing:border-box}
html,body,#root{height:100%}
body{
margin:0;
font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell,
Noto Sans, Helvetica Neue, Arial, "Apple Color Emoji","Segoe UI Emoji";
color:#0f172a;
background:#fff;
}
a{color:inherit; text-decoration:none}
img{display:block; max-width:100%; height:auto}
button{cursor:pointer; border:0; background:transparent}
`;

export default GlobalStyles;
